import { getUrlAction } from '../../utils'
import { estabelecimento } from '../estabelecimento'

export const BuscaDadosEstabelecimento = () => {
  // Busca os tipos de pagamento
  buscaTipoPagamento()
}
function buscaTipoPagamento() {
  axios
    .get(getUrlAction('Cadastros', 'BuscaTipoPagamentos'), {
      params: {
        urlEmpresa: estabelecimento.urlEmpresa,
      },
    })
    .then(processarTiposPagamento)
    .catch(reportarErro)

  function processarTiposPagamento({ data }) {
    if (data.length > 0) {
      processarBandeiras(data)
    }

    verificarSomenteDinheiro(data)

    estabelecimento.pagamento.metodos = data

    atualizaTextoCabecalho_FormasPagamento()
  }

  function processarBandeiras(data) {
    data.forEach((tipoPagamento) => {
      tipoPagamento.Bandeiras.forEach((bandeira) => {
        if (bandeira.Bandeira) {
          if (bandeira.IdBandeira && bandeira.IdBandeira !== 0) {
            bandeira.Bandeira.Id = bandeira.IdBandeira
          }
        }
      })
    })
  }

  function verificarSomenteDinheiro(data) {
    if (data.length === 1 && data[0].Prefixo === 'DIN') {
      estabelecimento.pagamento.somenteDinheiro = true
    }
  }

  function atualizaTextoCabecalho_FormasPagamento() {
    const pagamentosWrapper = select('#estabelecimento-pagamentos')

    if (
      estabelecimento.pagamento.metodos.length > 0 &&
      pagamentosWrapper &&
      !estabelecimento.qrCode.ativo
    ) {
      pagamentosWrapper.innerHTML = `
                    <div class="u-flex-column u-flex-start">
                        <div class="u-nowrap u-font-gray-dark u-font-12">Formas de pagamento</div>
                        <div class="pagamento-metodos u-font-w-450">${estabelecimento.pagamento.toString()}</div>
                    </div>
                `
    }
  }
}

function reportarErro(error) {
  throw new Error(estabelecimento.fantasia + ' | ' + error)
}
